import React, { useState, useEffect, useRef } from "react";
import { useGlobal } from "../global/user";

export default function FieldSelect() {
  const { user, field, setField, fields } = useGlobal();
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const canSearch = user?.class > 2;

  useEffect(() => {
    if (fields.length > 0 && field === -1) {
      setField(fields[0].field_id);
    }
  }, [setField, fields, field]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 場域被刪除時，user_field 可能留下孤兒資料，field_name 會是 null；
  // 這裡統一補上預設字串，避免整頁 render 失敗
  const fieldLabel = (opt) => opt?.field_name || `（未命名場域 #${opt?.field_id}）`;

  const keyword = searchTerm.toLowerCase();
  const filteredFields = fields.filter((opt) => fieldLabel(opt).toLowerCase().includes(keyword));

  const selectedField = fields.find((item) => item.field_id === field);
  const selectedFieldName = selectedField ? fieldLabel(selectedField) : "請選擇場域";

  return (
    <div className="select_group" ref={dropdownRef} style={{ position: "relative" }}>
      <div
        className="select_text"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: "pointer" }}
      >
        {selectedFieldName}
      </div>

      {isOpen && (
        <div
          className="dropdown_menu"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            border: "1px solid var(--border-color)",
            background: "var(--content-background)",
            color: "var(--primary-text)",
            zIndex: 10,
            maxHeight: "min(420px, 60vh)",
            overflowY: "auto",
            borderRadius: "0 0 5px 5px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          }}
        >
          {canSearch && (
            <input
              type="text"
              placeholder="搜尋場域..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 12px",
                boxSizing: "border-box",
                border: "none",
                borderBottom: "1px solid var(--border-color)",
                background: "transparent",
                color: "var(--primary-text)",
                outline: "none",
              }}
              autoFocus
            />
          )}

          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {filteredFields.length > 0 ? (
              filteredFields.map((opt) => {
                const isSelected = field === opt.field_id;
                return (
                  <li
                    key={opt.field_id}
                    onClick={() => {
                      setField(opt.field_id);
                      setIsOpen(false);
                      setSearchTerm("");
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = "#0078D4";
                        e.currentTarget.style.color = "#fff";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "var(--primary-text)";
                      }
                    }}
                    style={{
                      padding: "10px 15px",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                      backgroundColor: isSelected ? "var(--primary-border)" : "transparent",
                      color: isSelected ? "#fff" : "var(--primary-text)",
                    }}
                  >
                    {fieldLabel(opt)}
                  </li>
                );
              })
            ) : (
              <li style={{ padding: "10px 15px", color: "var(--secondary-text)" }}>無匹配結果</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}